﻿<template>
    <div class="px-2">
        <h4>Account Information</h4>

        <div class="form-contents">
            <div class="text-italic mt-4 mb-4">To amend your details please use the form below and click Send to email the changes to us, or alternatively contact us at <a @click="Email_Agency()">{{get_email_address()}}</a>.</div>
            <div class="grid grid-cols-1 gap-x-4 gap-y-2 lg:grid-cols-2 ">
                <div class="mb-1 font-bold">Name</div>
                <div class="mb-1">{{account_information.name}}</div>
                <div class="mb-1 font-bold">Address</div>
                <div class="mb-1">
                    <input type="text" name="address_1" id="address_1" spellcheck="false" v-model="account_information.address_1" class="input input-bordered w-full" />
                </div>
                <div class="mb-1"></div>
                <div class="mb-1">
                    <input type="text" name="address_2" id="address_2" spellcheck="false" v-model="account_information.address_2" class="input input-bordered w-full" />
                </div>
                <div class="mb-1 font-bold">Post Code</div>
                <div class="mb-1">
                    <input type="text" name="post_code" id="post_code" spellcheck="false" v-model="account_information.post_code" class="input input-bordered w-full" />
                </div>
                <div class="mb-1 font-bold">Phone Number</div>
                <div class="mb-1">
                    <input type="text" name="telephone" id="telephone" spellcheck="false" v-model="account_information.telephone" class="input input-bordered w-full" />
                </div>
                <div class="mb-1 font-bold">Email</div>
                <div class="mb-1">
                    <input type="text" name="email" id="email" spellcheck="false" v-model="account_information.email" class="input input-bordered w-full" />
                </div>
                <div class="mb-1 font-bold">Payment Method</div>
                <div class="mb-1">{{Payment_Methods()}}</div>
                <div class="mb-1 font-bold">Agent Code</div>
                <div class="mb-1">{{account_information.code}}</div>
            </div>
            <br />
            <div class="">
                <div class="button w-1/2 mx-auto cursor-pointer" @click="Email_Agency()" style="display: flex; justify-content: center;">
                    Send
                </div>
            </div>

        </div>
    </div>
</template>
<script lang="ts" src="./account_information.ts"></script>
